export default {
    somethingWrong: 'Something Wrong!!',
    close: 'Close'
}
